<template>
<div>
    <slot name="breadcrumb" />

    <agency-lead-modal />

    <div class="container agency mt-2 mb-4" id="agencymap">
        <h1>{{ lang.title.replace(':network', $root.network[0].toUpperCase() + $root.network.slice(1)).replace(':district', agency.district).replace(':city', agency.city.title).replace(':province', agency.province.title).replace(':region', agency.region.id != 1 ? agency.region.title : '') }}</h1>

        <div>
            <slot name="header"></slot>
            <div class="agency-card">
                <div class="agency-data align-items-center pt-0">
                    <img :src="'/img/icons/icon-' + agency.network + '.svg'" :alt="agency.network" width="38" height="35" />
                    <div class="agency-heading-data">
                        <div class="business-name">
                            <span class="affiliate-label">{{ lang.labels.affiliate }}:</span> {{ agency.name }}
                            <img v-if="agency.aicat" class="agency-aicat-img" :src="agency.aicat" />
                        </div>
                    </div>
                </div>

                <div class="d-flex align-items-center ml-auto fixflex">
                    <div class="links-container">
                        <a
                            v-if="agency.url_facebook"
                            :href="agency.url_facebook"
                            target="_blank"
                            rel="noopener"
                            class="btn btn-contact mr-1"
                        >
                            <masked-image src="/img/icons/facebook-big.svg"></masked-image>
                        </a>
                        <!-- <a
                            :href="agency.url_instagram"
                            target="_blank"
                            rel="noopener"
                            class="btn btn-contact ml-1"
                        >
                            <masked-image src="/img/icons/youtube-big.svg"></masked-image>
                        </a> -->
                        <a
                            v-if="agency.url_instagram"
                            :href="agency.url_instagram"
                            target="_blank"
                            rel="noopener"
                            class="btn btn-contact mr-1"
                        >
                            <masked-image src="/img/icons/instagram-big.svg"></masked-image>
                        </a>
                        <a
                            v-if="agency.url_linkedin"
                            :href="agency.url_linkedin"
                            target="_blank"
                            rel="noopener"
                            class="btn btn-contact mr-1"
                        >
                            <masked-image src="/img/icons/linkedin-big.svg"></masked-image>
                        </a>
                        <a
                            v-if="agency.url_twitter"
                            :href="agency.url_twitter"
                            target="_blank"
                            rel="noopener"
                            class="btn btn-contact mr-1"
                        >
                            <masked-image src="/img/icons/twitter-big.svg"></masked-image>
                        </a>
                    </div>
                    <div class="">
                        <a
                            v-if="agency.active && agency.url_agency"
                            :href="agency.url_agency"
                            class="btn btn-network"
                            target="_blank"
                            rel="noopener"
                        >
                            <span>{{ lang.labels.homepage }}</span>
                        </a>
                    </div>
                </div>
            </div>

            <div class="agency-card mt-3 d-block">
                <div class="row">
                    <div class="col-xl-4 col-md-4 agency-img-zone">
                        <img v-if="agency.url_image" :src="agency.url_image" width="100%" />
                        <img v-else src="/img/img-agency.svg" width="100%" />
                    </div>

                    <div class="col-xl-3 col-md-8 agency-data-img">
                        <div class="info">
                            <h3>{{ lang.labels.place }}</h3>
                            <div class="d-flex align-items-start mb-1">
                                <div class="p-2">
                                    <masked-image src="/img/icons/map.svg" class="ico_map"></masked-image>
                                </div>
                                <div>{{ agency.address }} <!-- {{ agency.zip_code }} {{ agency.city.title }} ({{ agency.province.id }}) --></div>
                            </div>

                            <div v-if="agency.opening_hours">
                                <h3>{{ lang.labels.hours }}</h3>
                                <div class="d-flex align-items-start mb-1">
                                    <div class="p-2">
                                        <masked-image src="/img/icons/hours.svg" class="ico_hours"></masked-image>
                                    </div>
                                    <div class="hours_scroll" >{{ agency.opening_hours }}</div>
                                </div>
                            </div>

                            <h3>{{ lang.labels.contacts }}</h3>
                            <div v-if="agency.status == 'ATTIVO' || agency.status == 'PRE_SOSPESO'">
                                <div class="d-flex align-items-center">
                                    <div class="p-2">
                                        <masked-image src="/img/icons/email.svg"></masked-image>
                                    </div>
                                    <div class="email">{{ agency.email }}</div>
                                </div>
                            </div>

                            <div v-if="agency.whatsapp">
                                <div class="d-flex align-items-center">
                                    <div class="p-2">
                                        <masked-image src="/img/icons/ico_whatsapp.svg"></masked-image>
                                    </div>
                                    <div class="whatsapp">
                                        <a :href="'https://wa.me/' + this.agency.whatsapp" target="_blank">{{ agency.whatsapp }}</a>
                                    </div>
                                </div>
                            </div>

                            <div v-if="agency.phone" class="phone-map">
                                <div class="d-flex align-items-center">
                                    <div class="p-2">
                                        <masked-image src="/img/icons/phone-agency.svg" :alt="agency.phone" style="width: 1rem"></masked-image>
                                    </div>
                                    <div class="phone">{{ agency.phone }}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-xl-5" v-if="agency.active">
                        <div class="banner view-properties mb-1 d-flex justify-content-between">
                            <div class="w-50 null"></div>
                            <div class="w-50">
                                <div class="p-1 title">{{ lang.site.title }}</div>
                                <div class="p-1">{{ lang.site.intro }}</div>
                                <div class="mt-auto p-1">
                                    <a :href="agency.url_agency" target="_blank">{{ lang.site.link }}</a>
                                </div>
                            </div>
                        </div>
                        <div class="banner sell-properties d-flex justify-content-between">
                            <div class="w-50 null"></div>
                            <div class="w-50">
                                <div class="p-1 title">{{ lang.evaluations.title }}</div>
                                <div class="p-1">{{ lang.evaluations.intro }}</div>
                                <div class="mt-auto p-1">
                                    <a :href="agency.url_agency + config.url.evaluations" target="_blank">{{ lang.evaluations.link }}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <agency-map
            v-if="isActive"
            :latitude="agency.latitude"
            :longitude="agency.longitude"
            :network="agency.network"
            :sector="agency.sector"
            :tecnomaps-endpoint="tecnomapEndpoint"
            :marker="marker"
        />

        <div v-if="agency.team">
            <div class="agency-team">
                <h4 class="agency-team-title">
                    <img src="/img/icons/agency-team.svg" />
                    {{ lang.labels.team }}
                </h4>
                <agency-team-carousel :team="agency.team" />
            </div>
        </div>

        <div v-if="$slots.description" class="desc-card">
                <h4 class="agency-team-title">
                <img src="/img/icons/agency-team.svg" />
                {{ lang.labels.description }}
                </h4>
            <slot name="description" />
        </div>

    </div>
</div>
</template>

<script>
import AgencyCard from '../../components/agencies/Card'
import AgencyLeadModal from '../../components/agencies/LeadModal'
import AgencyMap from '../../components/agencies/Map'
// import ModalOpener from '../../components/ModalOpener'
import AgencyTeamCarousel from '../../components/agencies/TeamCarousel'

export default {
    components: {
        'agency-card': AgencyCard,
        'agency-lead-modal': AgencyLeadModal,
        'agency-map': AgencyMap,
        // 'modal-opener': ModalOpener,
        'agency-team-carousel': AgencyTeamCarousel,
    },

    props: {
        agency: {
            type: Object,
            required: true,
        },

        config: {
            type: Object,
            required: true,
        },

        marker: {
            type: String,
            required: true,
        },

        tecnomapEndpoint: {
            type: String,
            required: true,
        },
    },

    computed: {
        isActive() {
            let allowed_statuses = ['ATTIVO', 'PRE_SOSPESO']

            return allowed_statuses.includes(this.agency.status)
        },
        lang() {
            return this.$root.lang.agency_card
        },
    },
}
</script>